import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false;

document.addEventListener("turbo:frame-load", (element) => {
  const frameId = element.target.id;
  Domestika.startElementEventsTracker(`#${frameId}`);
});
